import React from "react";
import {
    MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem
} from 'mdbreact';
import { connect } from 'react-redux';
import ReactDOM from "react-dom";
import PropTypes from 'prop-types';



import { GetEstadisticasTotalesAnnosEnAPI, GetEstadisticasTotalesEnAPI } from "../../action/actionCreatorsRequests";
import {
    convertirMoneda, convertirAMesACodigo,obtenerToken,
    traducirPagina, obtenerUsuario, obtenerFechaLocalObjeto, convertirCodigoAMeses

} from "../../librerias/funciones"

import {  Select, Row, Col, Card } from 'antd';

const { Option } = Select;

const EstadisticasMatriculas = ({ activeItemReferencia, configApp, props }) => {
    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);
    const ref = React.useRef(null)

    const [sociosLocal, setSociosLocal] = React.useState([]);
    const [socioSeleccionado, setSocioSeleccionado] = React.useState(0);

    const [seCambioElDia, setSeCambioElDia] = React.useState(true);
    const [seCambioElMes, setSeCambioElMes] = React.useState(false);
    const [seCambioElAnio, setSeCambioElAnio] = React.useState(false);

    const [estadisticasMatricula, setEstadisticasMatricula] = React.useState([]);
    const [estadisticasMatriculaGrupo, setEstadisticasMatriculaGrupo] = React.useState([]);
    const [mesesDelAnio, setMesesDelAnio] = React.useState(
        [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre",
        ]
    );
    const [mesSeleccionado, setMesSeleccionado] = React.useState("")
    const [anios, setAnios] = React.useState([]);
    const [anioSeleccionado, setAnioSeleccionado] = React.useState("")


    const buscarCondiciones = () => {
        let condiciones = { DESDE: "0", HASTA: "0" }
        if (seCambioElDia && !seCambioElMes && !seCambioElAnio) {
            condiciones.DESDE = "4"
            condiciones.HASTA = "5"
        } else if (!seCambioElDia && seCambioElMes && !seCambioElAnio) {
            condiciones.DESDE = "0"
            condiciones.HASTA = "1"
        } else if (!seCambioElDia && !seCambioElMes && seCambioElAnio) {
            condiciones.DESDE = "2"
            condiciones.HASTA = "3"
        }
        return condiciones;
    }



    const buscarEstadisticasMatriculas = (socio, codigoMes, Anio, condiciones) => {
        setEstadisticasMatricula([])
        let fechaLocal = obtenerFechaLocalObjeto(false);
        let crearFecha = ""

        if (condiciones.DESDE === "4" && condiciones.HASTA === "5") {
            crearFecha = fechaLocal.DIA + "/" + codigoMes + "/" + Anio
        } else if (condiciones.DESDE === "0" && condiciones.HASTA === "1") {
            crearFecha = "01" + "/" + codigoMes + "/" + Anio
        } else if (condiciones.DESDE === "2" && condiciones.HASTA === "3") {
            crearFecha = "01" + "/" + "01" + "/" + Anio
        }


        GetEstadisticasTotalesEnAPI(crearFecha, condiciones.DESDE, condiciones.HASTA, socio).then((registros) => {
            if (registros.REGISTROS !== undefined && registros.REGISTROS !== null && registros.REGISTROS.length > 0) {
                setEstadisticasMatricula(registros.REGISTROS)
            } else {
                setEstadisticasMatricula(null)
            }
        })
    }




    const buscarEstadisticasMatriculasGrupo = (socio, codigoMes, Anio, condiciones) => {
        setEstadisticasMatriculaGrupo([])
        let fechaLocal = obtenerFechaLocalObjeto(false);
        let crearFecha = ""
        // if (condiciones.DESDE === "1" && condiciones.HASTA === "2") {

        if (condiciones.DESDE === "4" && condiciones.HASTA === "5") {
            crearFecha = fechaLocal.DIA + "/" + codigoMes + "/" + Anio
        } else if (condiciones.DESDE === "0" && condiciones.HASTA === "1") {
            crearFecha = "01" + "/" + codigoMes + "/" + Anio
        } else if (condiciones.DESDE === "2" && condiciones.HASTA === "3") {
            crearFecha = "01" + "/" + "01" + "/" + Anio
        }


        GetEstadisticasTotalesEnAPI(crearFecha, condiciones.DESDE, condiciones.HASTA, socio).then((registros) => {
            if (registros.REGISTROS !== undefined && registros.REGISTROS !== null && registros.REGISTROS.length > 0) {
                setEstadisticasMatriculaGrupo(registros.REGISTROS)
            } else {
                setEstadisticasMatriculaGrupo(null)
            }
        })
    }



    const buscarAnios = (socio, codigoMes, Anio) => {

        let fechaLocal = obtenerFechaLocalObjeto(false);
        let crearFecha = fechaLocal.DIA + "/" + codigoMes + "/" + Anio

        GetEstadisticasTotalesAnnosEnAPI(crearFecha, "0", "0", socio).then((registros) => {
            if (registros.REGISTROS !== undefined && registros.REGISTROS !== null && registros.REGISTROS.length > 0) {
                setAnios(registros.REGISTROS)

            } else {
                setAnios(null)

            }

        })
    }


    /*

    if (!hayLicencias && activeItemReferencia === "ESTADISTICAS_MATRICULAS") {
        let accesoLicencia = obtenerUsuario();
        seHayLicencias(true)
        setSociosLocal(accesoLicencia.SOCIOS)
        setSocioSeleccionado(accesoLicencia.SOCIOS[0].ID_SOCIO)

        let fechaLocal = obtenerFechaLocalObjeto(false);
        setMesSeleccionado(convertirCodigoAMeses(fechaLocal.MES))
        setAnioSeleccionado(fechaLocal.ANIO)

        buscarEstadisticasMatriculas(accesoLicencia.SOCIOS[0].ID_SOCIO, fechaLocal.MES, fechaLocal.ANIO, buscarCondiciones())
        buscarAnios(accesoLicencia.SOCIOS[0].ID_SOCIO, fechaLocal.MES, fechaLocal.ANIO)


        buscarEstadisticasMatriculasGrupo(0, fechaLocal.MES, fechaLocal.ANIO, buscarCondiciones())

    } else {
        if (activeItemReferencia !== "ESTADISTICAS_MATRICULAS" && hayLicencias) {
            seHayLicencias(false)
            setEstadisticasMatricula([])
        }
    }
*/



    React.useEffect(() => {
        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }

    })




    React.useEffect(() => {
        if (obtenerToken() !== undefined) {
            let accesoLicencia = obtenerUsuario();
            setSociosLocal(accesoLicencia.SOCIOS)
            setSocioSeleccionado(accesoLicencia.SOCIOS[0].ID_SOCIO)

            let fechaLocal = obtenerFechaLocalObjeto(false);
            setMesSeleccionado(convertirCodigoAMeses(fechaLocal.MES))
            setAnioSeleccionado(fechaLocal.ANIO)

            buscarEstadisticasMatriculas(accesoLicencia.SOCIOS[0].ID_SOCIO, fechaLocal.MES, fechaLocal.ANIO, buscarCondiciones())
            buscarAnios(accesoLicencia.SOCIOS[0].ID_SOCIO, fechaLocal.MES, fechaLocal.ANIO)


            buscarEstadisticasMatriculasGrupo(0, fechaLocal.MES, fechaLocal.ANIO, buscarCondiciones())
        }

    }, [])



    document.getElementById("tituloMenu") !== null && ReactDOM.render(
        <>
            {`SERTEC - ${traducirPagina("Estadistica_matricula").toUpperCase()}`}
        </>,
        document.getElementById("tituloMenu")
    );



    return (
        <>
            <div className="menu_mantenimiento" ref={ref}>
                <div className="mantenimiento_item1">
                    {sociosLocal !== null ?
                        <Select
                            showSearch
                            allowClear={obtenerUsuario().SOCIOS.length > 1 ? true : false}
                            defaultValue={obtenerUsuario().SOCIOS[0].ID_SOCIO}
                            size={"large"}
                            placeholder={"Seleccione un socio"}
                            style={{ width: "400px" }}
                            onChange={(e) => {
                                setSeCambioElDia(true);
                                setSeCambioElMes(false);
                                setSeCambioElAnio(false);

                                if (e === undefined || e === null) {
                                    //buscarEstadisticasMatriculas(0, convertirAMesACodigo(mesSeleccionado), anioSeleccionado,buscarCondiciones())
                                    setEstadisticasMatricula(null)
                                    buscarEstadisticasMatriculasGrupo(0, obtenerFechaLocalObjeto(false).MES, obtenerFechaLocalObjeto(false).ANIO, { DESDE: "4", HASTA: "5" });
                                } else {
                                    buscarEstadisticasMatriculas(e, obtenerFechaLocalObjeto(false).MES, obtenerFechaLocalObjeto(false).ANIO, { DESDE: "4", HASTA: "5" })
                                    buscarEstadisticasMatriculasGrupo(0, obtenerFechaLocalObjeto(false).MES, obtenerFechaLocalObjeto(false).ANIO, { DESDE: "4", HASTA: "5" });

                                    setSocioSeleccionado(parseInt(e));
                                    buscarAnios(e, convertirAMesACodigo(mesSeleccionado), anioSeleccionado)

                                }
                            }}
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {sociosLocal.length > 0 ?
                                sociosLocal.map((socio) =>
                                    <Option key={socio.ID_SOCIO} value={socio.ID_SOCIO}>{socio.NOMBRE_SOCIO}</Option>
                                )
                                :
                                null
                            }
                        </Select>
                        :
                        <div style={{ textAlign: 'center' }}>
                            <h4>{traducirPagina("Info_error_socio")}</h4>
                        </div>
                    }
                </div>

                <div className="mantenimiento_item2">
                    
                    <div style={{ padding: '8px 20px', backgroundColor: seCambioElDia ? '#00468e' : '#a2a2a2', fontSize: '16px', fontWeight: '500', color: '#fff', textAlign: 'center', borderRadius: '4px 0px 0px 4px' }}
                        onClick={(e) => {
                            let anioActual = obtenerFechaLocalObjeto(false).ANIO;
                            setAnioSeleccionado(anioActual);

                            setSeCambioElDia(true);
                            setSeCambioElMes(false);
                            setSeCambioElAnio(false);
                            //anioSeleccionado
                            buscarEstadisticasMatriculas(socioSeleccionado, obtenerFechaLocalObjeto(false).MES, anioActual, { DESDE: "4", HASTA: "5" });
                            buscarEstadisticasMatriculasGrupo(0, obtenerFechaLocalObjeto(false).MES, anioActual, { DESDE: "4", HASTA: "5" });

                        }}>
                        {traducirPagina("Hoy").toUpperCase()}
                    </div>



                    <MDBDropdown>
                        <MDBDropdownToggle nav>
                            <div style={{ padding: '8px 20px', backgroundColor: seCambioElMes ? '#00468e' : '#a2a2a2', fontSize: '16px', fontWeight: '500', color: '#fff' }}>
                                {mesSeleccionado.toUpperCase()}
                            </div>
                        </MDBDropdownToggle>

                        <MDBDropdownMenu right >
                            {mesesDelAnio.map((mes, i) =>
                                <MDBDropdownItem key={i} onClick={(e) => {
                                    setSeCambioElDia(false);
                                    setSeCambioElAnio(false);
                                    setMesSeleccionado(e.target.innerText);

                                    buscarEstadisticasMatriculas(socioSeleccionado, convertirAMesACodigo(e.target.innerText), anioSeleccionado, { DESDE: "0", HASTA: "1" });
                                    buscarEstadisticasMatriculasGrupo(0, convertirAMesACodigo(e.target.innerText), anioSeleccionado, { DESDE: "0", HASTA: "1" });
                                    setSeCambioElMes(true)
                                }}>  {mes.toUpperCase()}</MDBDropdownItem>
                            )}
                        </MDBDropdownMenu>
                    </MDBDropdown>


                    <MDBDropdown>

                        <MDBDropdownToggle nav>
                            <div style={{ padding: '8px 20px', backgroundColor: seCambioElAnio ? '#00468e' : '#a2a2a2', fontSize: '16px', fontWeight: '500', color: '#fff', borderRadius: '0px 4px 4px 0px' }}>
                                {anioSeleccionado}
                            </div>
                        </MDBDropdownToggle>


                        <MDBDropdownMenu right >
                            {anios !== null ?
                                anios.map((anio, i) =>
                                    <MDBDropdownItem key={i} onClick={(e) => {
                                        setSeCambioElDia(false);
                                        setSeCambioElMes(false);
                                        setAnioSeleccionado(e.target.innerText);
                                        buscarEstadisticasMatriculas(socioSeleccionado, convertirAMesACodigo(mesSeleccionado), e.target.innerText, { DESDE: "2", HASTA: "3" });
                                        buscarEstadisticasMatriculasGrupo(0, convertirAMesACodigo(mesSeleccionado), e.target.innerText, { DESDE: "2", HASTA: "3" });
                                        setSeCambioElAnio(true)
                                    }}>  {anio.ANYO}</MDBDropdownItem>
                                )
                                :
                                null
                            }
                        </MDBDropdownMenu>
                    </MDBDropdown>


                </div>
            </div>


            <div style={{ padding: '20px' }}>

                <Row gutter={[8, 8]}>

                    <Col span={8}>
                        <Card bordered={false} style={{ backgroundColor: 'var(--gris-serca)' }}>
                            {estadisticasMatriculaGrupo === null ?
                                <div style={{ fontSize: '20px', fontWeight: '500' }}>{traducirPagina("Sin_resultados")} </div>
                                :
                                estadisticasMatriculaGrupo.length > 0 ?
                                    <div>

                                        <table className="tablaEstadistica">
                                            <thead>
                                                <tr>
                                                    <th colSpan={2}>{traducirPagina("Consulta_grupo").toUpperCase()}</th>
                                                    <th></th>
                                                    <th>{convertirMoneda(estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS, "")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_CORRECTAS_CIENTO + "%"}</td>
                                                    <td style={{ width: '100%' }}><div style={{ backgroundColor: '#f1f1f1' }}> <div style={{ backgroundColor: '#007bff', width: estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_CORRECTAS_CIENTO + '%', height: '25px' }}></div></div> </td>
                                                    <td>{"OK "}</td>
                                                    <td style={{ textAlign: 'right' }}>{convertirMoneda(estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_CORRECTAS, "")}</td>
                                                </tr>

                                                <tr>
                                                    <td>{estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_ERRORES_CIENTO + "%"}</td>
                                                    <td style={{ width: '100%' }}><div style={{ backgroundColor: '#f1f1f1' }}> <div style={{ backgroundColor: '#007bff', width: estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_ERRORES_CIENTO + '%', height: '25px' }}></div></div></td>
                                                    <td>{"KO "} </td>
                                                    <td style={{ textAlign: 'right' }}>{convertirMoneda(estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_ERRORES, "")}</td>
                                                </tr>

                                                <tr>
                                                    <td>{estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_COBRADAS_CIENTO + "%"}</td>
                                                    <td style={{ width: '100%' }}><div style={{ backgroundColor: '#f1f1f1' }}> <div style={{ backgroundColor: '#007bff', width: estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_COBRADAS_CIENTO + '%', height: '25px' }}></div></div></td>
                                                    <td>{traducirPagina("Cobradas").toUpperCase()} </td>
                                                    <td style={{ textAlign: 'right' }}>{convertirMoneda(estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_COBRADAS, "")}</td>
                                                </tr>

                                                <tr>
                                                    <td>{estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_REPETIDAS_CIENTO + "%"}</td>
                                                    <td style={{ width: '100%' }}><div style={{ backgroundColor: '#f1f1f1' }}><div style={{ backgroundColor: '#007bff', width: estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_REPETIDAS_CIENTO + '%', height: '25px' }}></div></div></td>
                                                    <td> {traducirPagina("Sin_cobrar")}</td>
                                                    <td style={{ textAlign: 'right' }}>{convertirMoneda(estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_REPETIDAS_SIN_COBRAR, "")}</td>
                                                </tr>
                                                <tr>
                                                    <td>{estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_REPETIDAS_DIFERENTES_CIENTO + "%"}</td>
                                                    <td style={{ width: '100%' }}><div style={{ backgroundColor: '#f1f1f1' }}> <div style={{ backgroundColor: '#007bff', width: estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_REPETIDAS_DIFERENTES_CIENTO + '%', height: '25px' }}></div></div></td>
                                                    <td>{traducirPagina("Repeticiones")}</td>
                                                    <td style={{ textAlign: 'right' }}>{convertirMoneda(estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_MATRICULAS_REPETIDAS_SIN_COBRAR_DIFERENTES, "")}</td>

                                                </tr>
                                            </tbody>
                                        </table>


                                        {/* 
                                        <Row>
                                            <Col span={18} style={{ fontSize: '13px', fontWeight: '500' }}>
                                                <div style={{ fontSize: '20px', fontWeight: '500' }}>{traducirPagina("Consulta_grupo").toUpperCase()} </div>
                                            </Col>
                                            <Col span={6}>
                                                <div style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}>{convertirMoneda(estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS, "")} </div>
                                            </Col>
                                        </Row>

                                        <div className="flex_container_Matricula">
                                            <div style={{ width: '50px' }}>{estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_CORRECTAS_CIENTO + "%"}</div>
                                            <div style={{ backgroundColor: '#f1f1f1', width: configApp.width > 1450 ? '200px' : '100px' }}>
                                                <div style={{ backgroundColor: '#007bff', width: estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_CORRECTAS_CIENTO + '%', height: '100%' }}></div>
                                            </div>
                                            <div>{"OK "}</div>

                                            <div style={{ width: '175px', textAlign: 'right' }}>{convertirMoneda(estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_CORRECTAS, "")}</div>

                                        </div>


                                        <div className="flex_container_Matricula">
                                            <div style={{ width: '50px' }}>{estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_ERRORES_CIENTO + "%"}</div>
                                            <div style={{ backgroundColor: '#f1f1f1', width: configApp.width > 1450 ? '200px' : '100px' }}>
                                                <div style={{ backgroundColor: '#007bff', width: estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_ERRORES_CIENTO + '%', height: '100%' }}></div>
                                            </div>
                                            <div>{"KO "}</div>

                                            <div style={{ width: '175px', textAlign: 'right' }}>{convertirMoneda(estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_ERRORES, "")}</div>

                                            <div style={{ height: '100%', backgroundColor: '#007bff', color: '#fff', display: 'none' }}>
                                                <Row style={{ padding: '0px 5px 0px' }}>
                                                    <Col span={6} style={{ fontSize: '13px', fontWeight: '500' }}>
                                                        <PlusOutlined />
                                                    </Col>
                                                    <Col span={18} >
                                                        Info
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>

                                        <div className="flex_container_Matricula">
                                            <div style={{ width: '50px' }}>{estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_COBRADAS_CIENTO + "%"}</div>
                                            <div style={{ backgroundColor: '#f1f1f1', width: configApp.width > 1450 ? '200px' : '100px' }}>
                                                <div style={{ backgroundColor: '#007bff', width: estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_COBRADAS_CIENTO + '%', height: '100%' }}></div>
                                            </div>
                                            <div >{traducirPagina("Cobradas").toUpperCase()} </div>
                                            <div style={{ width: '110px', textAlign: 'right' }}>{convertirMoneda(estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_COBRADAS, "")}</div>

                                        </div>

                                        <div className="flex_container_Matricula">
                                            <div style={{ width: '50px' }}>{estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_REPETIDAS_CIENTO + "%"}</div>
                                            <div style={{ backgroundColor: '#f1f1f1', width: configApp.width > 1450 ? '200px' : '100px' }}>
                                                <div style={{ backgroundColor: '#007bff', width: estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_REPETIDAS_CIENTO + '%', height: '100%' }}></div>
                                            </div>
                                            <div >{traducirPagina("Sin_cobrar")}</div>
                                            <div style={{ width: '100px', textAlign: 'right' }}>{convertirMoneda(estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_REPETIDAS_SIN_COBRAR, "")}</div>

                                        </div>

                                        <div className="flex_container_Matricula">
                                            <div style={{ width: '50px' }}>{estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_REPETIDAS_DIFERENTES_CIENTO + "%"}</div>
                                            <div style={{ backgroundColor: '#f1f1f1', width: configApp.width > 1450 ? '200px' : '100px' }}>
                                                <div style={{ backgroundColor: '#007bff', width: estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_REPETIDAS_DIFERENTES_CIENTO + '%', height: '100%' }}></div>
                                            </div>
                                            <div>{traducirPagina("Repeticiones")}</div>
                                            <div style={{ width: '80px', textAlign: 'right' }}>{convertirMoneda(estadisticasMatriculaGrupo[0].TOTAL_CONSULTAS_MATRICULAS_REPETIDAS_SIN_COBRAR_DIFERENTES, "")}</div>
                                        </div>
*/}


                                    </div>
                                    :
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '30vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                            }
                        </Card>
                    </Col>

                    <Col span={8}>
                        <Card bordered={false} style={{ backgroundColor: 'var(--gris-serca)' }}>
                            {estadisticasMatricula === null ?
                                <div style={{ fontSize: '20px', fontWeight: '500' }}>{traducirPagina("Sin_resultados")} </div>
                                :
                                estadisticasMatricula.length > 0 ?
                                    <div>
                                        <table className="tablaEstadistica">
                                            <thead>
                                                <tr>
                                                    <th colSpan={2}>{traducirPagina("Mis_consultas").toUpperCase()}</th>
                                                    <th></th>
                                                    <th>{convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS, "")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{estadisticasMatricula[0].TOTAL_CONSULTAS_CORRECTAS_CIENTO + "%"}</td>
                                                    <td style={{ width: '100%' }}><div style={{ backgroundColor: '#f1f1f1' }}> <div style={{ backgroundColor: '#007bff', width: estadisticasMatricula[0].TOTAL_CONSULTAS_CORRECTAS_CIENTO + '%', height: '25px' }}></div></div> </td>
                                                    <td>{"OK "}</td>
                                                    <td style={{ textAlign: 'right' }}>{convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS_CORRECTAS, "")}</td>
                                                </tr>

                                                <tr>
                                                    <td>{estadisticasMatricula[0].TOTAL_CONSULTAS_ERRORES_CIENTO + "%"}</td>
                                                    <td style={{ width: '100%' }}><div style={{ backgroundColor: '#f1f1f1' }}> <div style={{ backgroundColor: '#007bff', width: estadisticasMatricula[0].TOTAL_CONSULTAS_ERRORES_CIENTO + '%', height: '25px' }}></div></div></td>
                                                    <td>{"KO "} </td>
                                                    <td style={{ textAlign: 'right' }}>{convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS_ERRORES, "")}</td>
                                                </tr>

                                                <tr>
                                                    <td>{estadisticasMatricula[0].TOTAL_CONSULTAS_COBRADAS_CIENTO + "%"}</td>
                                                    <td style={{ width: '100%' }}><div style={{ backgroundColor: '#f1f1f1' }}> <div style={{ backgroundColor: '#007bff', width: estadisticasMatricula[0].TOTAL_CONSULTAS_COBRADAS_CIENTO + '%', height: '25px' }}></div></div></td>
                                                    <td>{traducirPagina("Cobradas").toUpperCase()} </td>
                                                    <td style={{ textAlign: 'right' }}>{convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS_COBRADAS, "")}</td>
                                                </tr>

                                                <tr>
                                                    <td>{estadisticasMatricula[0].TOTAL_CONSULTAS_REPETIDAS_CIENTO + "%"}</td>
                                                    <td style={{ width: '100%' }}><div style={{ backgroundColor: '#f1f1f1' }}><div style={{ backgroundColor: '#007bff', width: estadisticasMatricula[0].TOTAL_CONSULTAS_REPETIDAS_CIENTO + '%', height: '25px' }}></div></div></td>
                                                    <td> {traducirPagina("Sin_cobrar")}</td>
                                                    <td style={{ textAlign: 'right' }}>{convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS_REPETIDAS_SIN_COBRAR, "")}</td>
                                                </tr>

                                                <tr>
                                                    <td>{estadisticasMatricula[0].TOTAL_CONSULTAS_REPETIDAS_DIFERENTES_CIENTO + "%"}</td>
                                                    <td style={{ width: '100%' }}><div style={{ backgroundColor: '#f1f1f1' }}> <div style={{ backgroundColor: '#007bff', width: estadisticasMatricula[0].TOTAL_CONSULTAS_REPETIDAS_DIFERENTES_CIENTO + '%', height: '25px' }}></div></div></td>
                                                    <td>{traducirPagina("Repeticiones")}</td>
                                                    <td style={{ textAlign: 'right' }}>{convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS_MATRICULAS_REPETIDAS_SIN_COBRAR_DIFERENTES, "")}</td>

                                                </tr>
                                            </tbody>
                                        </table>


                                        {/* 
                                        <Row>
                                            <Col span={18} style={{ fontSize: '13px', fontWeight: '500' }}>
                                                <div style={{ fontSize: '20px', fontWeight: '500' }}>{traducirPagina("Mis_consultas").toUpperCase()} </div>
                                            </Col>
                                            <Col span={6}>
                                                <div style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}>{convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS, "")} </div>
                                            </Col>
                                        </Row>



                                        <div className="flex_container_Matricula">
                                            <div style={{ width: '50px' }}>{estadisticasMatricula[0].TOTAL_CONSULTAS_CORRECTAS_CIENTO + "%"}</div>
                                            <div style={{ backgroundColor: '#f1f1f1', width: configApp.width > 1450 ? '200px' : '100px' }}>
                                                <div style={{ backgroundColor: '#007bff', width: estadisticasMatricula[0].TOTAL_CONSULTAS_CORRECTAS_CIENTO + '%', height: '100%' }}></div>
                                            </div>
                                            <div>{"OK "}</div>
                                            <div style={{ width: '175px', textAlign: 'right' }}>{convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS_CORRECTAS, "")}</div>

                                        </div>



                                        <div className="flex_container_Matricula">
                                            <div style={{ width: '50px' }}>{estadisticasMatricula[0].TOTAL_CONSULTAS_ERRORES_CIENTO + "%"}</div>
                                            <div style={{ backgroundColor: '#f1f1f1', width: configApp.width > 1450 ? '200px' : '100px' }}>
                                                <div style={{ backgroundColor: '#007bff', width: estadisticasMatricula[0].TOTAL_CONSULTAS_ERRORES_CIENTO + '%', height: '100%' }}></div>
                                            </div>
                                            <div>{"KO "}</div>

                                            <div style={{ width: '175px', textAlign: 'right' }}>{convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS_ERRORES, "")}</div>

                                            <div style={{ height: '100%', backgroundColor: '#007bff', color: '#fff', display: 'none' }}>
                                                <Row style={{ padding: '0px 5px 0px' }}>
                                                    <Col span={6} style={{ fontSize: '13px', fontWeight: '500' }}>
                                                        <PlusOutlined />
                                                    </Col>
                                                    <Col span={18} >
                                                        Info
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>


                                        <div className="flex_container_Matricula">
                                            <div style={{ width: '50px' }}>{estadisticasMatricula[0].TOTAL_CONSULTAS_COBRADAS_CIENTO + "%"}</div>
                                            <div style={{ backgroundColor: '#f1f1f1', width: configApp.width > 1450 ? '200px' : '100px' }}>
                                                <div style={{ backgroundColor: '#007bff', width: estadisticasMatricula[0].TOTAL_CONSULTAS_COBRADAS_CIENTO + '%', height: '100%' }}></div>
                                            </div>
                                            <div >{traducirPagina("Cobradas").toUpperCase()} </div>
                                            <div style={{ width: '110px', textAlign: 'right' }}>{convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS_COBRADAS, "")}</div>

                                        </div>

                                        <div className="flex_container_Matricula">
                                            <div style={{ width: '50px' }}>{estadisticasMatricula[0].TOTAL_CONSULTAS_REPETIDAS_CIENTO + "%"}</div>
                                            <div style={{ backgroundColor: '#f1f1f1', width: configApp.width > 1450 ? '200px' : '100px' }}>
                                                <div style={{ backgroundColor: '#007bff', width: estadisticasMatricula[0].TOTAL_CONSULTAS_REPETIDAS_CIENTO + '%', height: '100%' }}></div>
                                            </div>
                                            <div >{traducirPagina("Sin_cobrar")}</div>
                                            <div style={{ width: '100px', textAlign: 'right' }}>{convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS_REPETIDAS_SIN_COBRAR, "")}</div>

                                        </div>

                                        <div className="flex_container_Matricula">
                                            <div style={{ width: '50px' }}>{estadisticasMatricula[0].TOTAL_CONSULTAS_REPETIDAS_DIFERENTES_CIENTO + "%"}</div>
                                            <div style={{ backgroundColor: '#f1f1f1', width: configApp.width > 1450 ? '200px' : '100px' }}>
                                                <div style={{ backgroundColor: '#007bff', width: estadisticasMatricula[0].TOTAL_CONSULTAS_REPETIDAS_DIFERENTES_CIENTO + '%', height: '100%' }}></div>
                                            </div>
                                            <div>{traducirPagina("Repeticiones")}</div>
                                            <div style={{ width: '80px', textAlign: 'right' }}>{convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS_MATRICULAS_REPETIDAS_SIN_COBRAR_DIFERENTES, "")}</div>

                                        </div>
*/}

                                    </div>
                                    :
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '30vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>

                            }
                        </Card>
                    </Col>

                </Row>
            </div>
        </>
    );
}


EstadisticasMatriculas.propTypes = {
    EVENTO_MENU: PropTypes.func
};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        configApp: state.configApp,
        activeItemReferencia: state.activeItemReferencia,




    };
}

export default connect(mapStateToProps)(EstadisticasMatriculas);







